import { UserResponse } from './types';

export const getFullName = (user: UserResponse | null) => {
    const { firstName, lastName } = user ?? {};
    return (!firstName && !lastName) ? '' : `${firstName} ${lastName}`;
};

export const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];
